// import React, { useState, useEffect, useRef, memo, useCallback, useMemo } from 'react';
// import { useColorMode } from '@chakra-ui/react';
// import { VariableSizeList as List } from 'react-window';
// import InfiniteLoader from 'react-window-infinite-loader';
// import { useDispatch, useSelector } from 'react-redux';
// import { useUser } from 'contexts';
// import { DeleteIcon, EditIcon, CloseIcon, InfoIcon } from '@chakra-ui/icons';

// // Date formatting utility function
// const formatDate = (dateString) => {
//    if (!dateString) return '-';

//    try {
//       const date = new Date(dateString);
//       if (isNaN(date.getTime())) return '-';

//       const day = date.getDate().toString().padStart(2, '0');
//       const month = (date.getMonth() + 1).toString().padStart(2, '0');
//       const year = date.getFullYear();

//       return `${day}/${month}/${year}`;
//    } catch (error) {
//       return '-';
//    }
// };

// // Check if a field is likely a date field
// const isDateField = (fieldName, value) => {
//    const dateFields = ['date', 'createdAt', 'updatedAt', 'transactionAt', 'txnDate'];

//    const isDateFieldName = dateFields.some((field) => fieldName.toLowerCase().includes(field.toLowerCase()));
//    const isDateValue =
//       typeof value === 'string' && (/^\d{4}-\d{2}-\d{2}/.test(value) || /^\d{2}\/\d{2}\/\d{4}/.test(value));

//    return isDateFieldName || isDateValue;
// };

// const formatBalance = (value) => {
//    const numValue = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : Number(value);

//    if (isNaN(numValue)) {
//       return {
//          text: `0.00 CR`,
//          color: 'red.500',
//       };
//    }

//    const isNegative = numValue < 0;
//    const absValue = Math.abs(numValue);
//    const formatted = absValue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

//    return {
//       text: isNegative ? `${formatted} DB` : `${formatted} CR`,
//       color: isNegative ? 'green.500' : 'red.500',
//    };
// };
// const formatAmountWithLabel = (value) => {
//    const numValue = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : Number(value);

//    if (isNaN(numValue)) {
//       return '0.00';
//    }

//    const absValue = Math.abs(numValue);
//    const formatted = absValue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

//    return formatted;
// };

// const DynamicTable = ({
//    data,
//    right,
//    receiveRight,
//    paymentRight,
//    handleViewSingleData,
//    handleStatusChange,
//    columnVisibility,
//    pagename = true,
//    columnsData,
//    sorting,
//    limit = 20,
//    setCurrentRow,
//    onOpen,
//    setIsEditMode,
//    setIsOpenSingleView,
//    setDeleteDialogOpen,
//    onDeleteClick,
//    onMultiDeleteClick,
//    setSelectedRowId,
//    debouncedSearchQuery,
//    totalCount,
//    type,
//    entityType,
//    emptyMessage,
//    onLogClick,
//    fetchMoreData,
//    isAbs = false,
// }) => {
//    const { user } = useUser();
//    const { colorMode } = useColorMode();
//    const isDark = colorMode === 'dark';

//    const StatusSwitch = memo(({ isActive, cityId, onStatusChange, isDisabled = false }) => {
//       const [isLoading, setIsLoading] = useState(false);

//       const handleStatusToggle = async () => {
//          if (isDisabled) return;

//          setIsLoading(true);
//          try {
//             const newStatus = !isActive;
//             await onStatusChange(cityId, newStatus);
//             setIsOpenSingleView(false);
//          } catch (error) {
//             console.error('Failed to update status');
//          } finally {
//             setIsLoading(false);
//          }
//       };

//       return (
//          <div className="flex items-center gap-2">
//             <button
//                onClick={handleStatusToggle}
//                disabled={isDisabled || isLoading}
//                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 shadow-sm ${
//                   isActive
//                      ? 'bg-gradient-to-r from-emerald-500 to-emerald-600 focus:ring-emerald-500'
//                      : isDark
//                      ? 'bg-slate-700 focus:ring-slate-500'
//                      : 'bg-gray-300 focus:ring-gray-400'
//                } ${isDisabled || isLoading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:shadow-md'}`}>
//                <span
//                   className={`inline-block h-4 w-4 transform rounded-full bg-white shadow-lg transition-transform duration-300 ${
//                      isActive ? 'translate-x-6' : 'translate-x-1'
//                   }`}
//                />
//             </button>
//             {isLoading && <div className="text-xs text-gray-500">Updating...</div>}
//          </div>
//       );
//    });

//    // Skeleton Loader Component
//    const SkeletonRow = memo(({ style }) => (
//       <div style={style}>
//          <div
//             className={`flex items-center px-4 py-3 border-b animate-pulse ${
//                isDark ? 'border-slate-800/80 bg-slate-900/40' : 'border-gray-200/60 bg-gray-50/40'
//             }`}>
//             {/* Checkbox skeleton */}
//             <div className="flex-none w-12 sm:w-14 md:w-16 px-1 sm:px-2">
//                <div className={`w-4 h-4 rounded-md ${isDark ? 'bg-slate-700' : 'bg-gray-300'}`} />
//             </div>

//             {/* Actions skeleton */}
//             {!['city', 'state', 'country'].includes(type?.toLowerCase()) && (
//                <div className="flex-none w-24 sm:w-28 md:w-32 lg:w-36 px-1 sm:px-2">
//                   <div className="flex gap-1.5">
//                      <div className={`w-8 h-8 rounded-lg ${isDark ? 'bg-slate-700' : 'bg-gray-300'}`} />
//                      <div className={`w-8 h-8 rounded-lg ${isDark ? 'bg-slate-700' : 'bg-gray-300'}`} />
//                      <div className={`w-8 h-8 rounded-lg ${isDark ? 'bg-slate-700' : 'bg-gray-300'}`} />
//                   </div>
//                </div>
//             )}

//             {/* Data columns skeleton */}
//             <div className="flex-1">
//                <div className="flex items-center gap-4">
//                   {columnsData
//                      ?.filter((column) => columnVisibility[column.id])
//                      ?.map((column, idx) => (
//                         <div key={idx} className="flex-1">
//                            <div
//                               className={`h-5 rounded ${isDark ? 'bg-slate-700' : 'bg-gray-300'}`}
//                               style={{ width: `${60 + Math.random() * 40}%` }}
//                            />
//                         </div>
//                      ))}
//                </div>
//             </div>
//          </div>
//       </div>
//    ));

//    const VirtualRow = memo(({ index, style, data }) => {
//       const logIconShow = type === 'cash' || type === 'bank';
//       const editDeleteRight = type === 'cash' || type === 'bank';

//       const getStatusText = (status) => {
//          switch (status) {
//             case 0:
//                return {
//                   text: 'Pending',
//                   className: isDark
//                      ? 'text-amber-400 bg-amber-500/10 border border-amber-500/40 shadow-amber-500/10'
//                      : 'text-amber-700 bg-gradient-to-br from-amber-50 to-amber-100/50 border border-amber-300 shadow-sm',
//                };
//             case 1:
//                return {
//                   text: 'Approved',
//                   className: isDark
//                      ? 'text-emerald-400 bg-emerald-500/10 border border-emerald-500/40 shadow-emerald-500/10'
//                      : 'text-emerald-700 bg-gradient-to-br from-emerald-50 to-emerald-100/50 border border-emerald-300 shadow-sm',
//                };
//             case 2:
//                return {
//                   text: 'Rejected',
//                   className: isDark
//                      ? 'text-rose-400 bg-rose-500/10 border border-rose-500/40 shadow-rose-500/10'
//                      : 'text-rose-700 bg-gradient-to-br from-rose-50 to-rose-100/50 border border-rose-300 shadow-sm',
//                };
//             default:
//                return { text: '', className: '' };
//          }
//       };

//       const ref = useRef();
//       const {
//          items,
//          columnVisibility,
//          columnsData,
//          onDeleteClick,
//          onEditClick,
//          selectedRows,
//          onRowSelect,
//          Admin,
//          right,
//          receiveRight,
//          paymentRight,
//          setSize,
//          onStatusChange,
//          onLogClick,
//          isAbs,
//       } = data;
//       const item = items[index];

//       useEffect(() => {
//          if (ref.current) {
//             setSize(index, ref.current.getBoundingClientRect().height);
//          }
//       }, [index, item]);

//       // Show skeleton loader for items being loaded
//       if (!item) {
//          return <SkeletonRow style={style} />;
//       }

//       // Handle row click - only for the main row area, not interactive elements
//       const handleRowClick = (e) => {
//          // Don't trigger if click originated from an interactive element
//          if (
//             e.target.tagName === 'BUTTON' ||
//             e.target.tagName === 'INPUT' ||
//             e.target.closest('button') ||
//             e.target.closest('input') ||
//             e.target.closest('[role="button"]')
//          ) {
//             return;
//          }
//          data?.handleViewSingleData?.(item.id);
//       };

//       return (
//          <div style={style}>
//             <div>
//                <div
//                   ref={ref}
//                   className={`flex items-center px-4 py-1 transition-all duration-200 border-b group ${
//                      isDark
//                         ? 'border-slate-800/80 hover:bg-gradient-to-r hover:from-slate-800/60 hover:to-slate-800/40 hover:border-slate-700'
//                         : 'border-gray-200/60 hover:bg-gradient-to-r hover:from-blue-50/40 hover:to-indigo-50/30 hover:border-blue-200/40 hover:shadow-sm'
//                   } ${
//                      selectedRows.includes(item.id)
//                         ? isDark
//                            ? 'bg-blue-500/10 border-blue-500/30'
//                            : 'bg-blue-50/70 border-blue-300/50'
//                         : ''
//                   }`}>
//                   {/* Checkbox Column */}
//                   <div className="flex-none w-12 sm:w-14 md:w-16 px-1 sm:px-2">
//                      <input
//                         type="checkbox"
//                         checked={selectedRows.includes(item.id)}
//                         onChange={(e) => {
//                            e.stopPropagation();
//                            onRowSelect(item.id);
//                         }}
//                         className={`w-4 h-4 rounded-md transition-all duration-200 cursor-pointer ${
//                            isDark
//                               ? 'bg-slate-800 border-slate-600 text-blue-500 focus:ring-blue-500/40 focus:ring-offset-slate-900 checked:bg-blue-500 checked:border-blue-500'
//                               : 'bg-white border-gray-300 text-blue-600 focus:ring-blue-500/40 focus:ring-offset-white checked:bg-blue-600 checked:border-blue-600'
//                         } focus:ring-2 focus:ring-offset-2 hover:border-blue-400`}
//                      />
//                   </div>

//                   {/* Actions Column */}
//                   {!['city', 'state', 'country'].includes(type?.toLowerCase()) &&
//                      ((user && !user.isExpired) || logIconShow) && (
//                         <div className="flex-none w-24 sm:w-28 md:w-32 lg:w-36 px-1 sm:px-2">
//                            <div className="flex gap-1 sm:gap-1.5 justify-start">
//                               {logIconShow && (
//                                  <button
//                                     onClick={(e) => {
//                                        e.stopPropagation();
//                                        onLogClick(item);
//                                     }}
//                                     className={`p-1.5 sm:p-2 rounded-lg transition-all duration-200 transform hover:scale-110 ${
//                                        isDark
//                                           ? 'text-blue-400 hover:bg-blue-500/20 hover:text-blue-300 hover:shadow-lg hover:shadow-blue-500/20'
//                                           : 'text-blue-600 hover:bg-blue-100 hover:text-blue-700 hover:shadow-md hover:shadow-blue-200/50'
//                                     } focus:outline-none focus:ring-2 focus:ring-blue-500/40`}
//                                     tabIndex={-1}>
//                                     <InfoIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
//                                  </button>
//                               )}

//                               {/* Edit Button */}
//                               {(Admin ||
//                                  (type === 'cash' || type === 'bank'
//                                     ? editDeleteRight &&
//                                       (item?.txnType === 0
//                                          ? receiveRight?.edit
//                                          : item?.txnType === 1
//                                          ? paymentRight?.edit
//                                          : true)
//                                     : right?.edit)) &&
//                                  (entityType === 'Unit' ? item?.usercode : true) &&
//                                  (entityType === 'Group' ? item?.userCode : true) &&
//                                  user &&
//                                  !user.isExpired && (
//                                     <button
//                                        onClick={(e) => {
//                                           e.stopPropagation();
//                                           onEditClick(item);
//                                        }}
//                                        className={`p-1.5 sm:p-2 rounded-lg transition-all duration-200 transform hover:scale-110 ${
//                                           isDark
//                                              ? 'text-emerald-400 hover:bg-emerald-500/20 hover:text-emerald-300 hover:shadow-lg hover:shadow-emerald-500/20'
//                                              : 'text-emerald-600 hover:bg-emerald-100 hover:text-emerald-700 hover:shadow-md hover:shadow-emerald-200/50'
//                                        } focus:outline-none focus:ring-2 focus:ring-emerald-500/40`}>
//                                        <EditIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
//                                     </button>
//                                  )}

//                               {/* Delete Button */}
//                               {(Admin ||
//                                  (type === 'cash' || type === 'bank'
//                                     ? editDeleteRight &&
//                                       (item?.txnType === 0
//                                          ? receiveRight?.deleteRole
//                                          : item?.txnType === 1
//                                          ? paymentRight?.deleteRole
//                                          : true)
//                                     : right?.deleteRole)) &&
//                                  (entityType === 'Unit' ? item?.usercode : true) &&
//                                  (entityType === 'Group' ? item?.userCode : true) &&
//                                  user &&
//                                  !user.isExpired &&
//                                  !item?.isAbs && ( // Changed from !isAbs to !item?.isAbs
//                                     <button
//                                        onClick={(e) => {
//                                           e.stopPropagation();
//                                           onDeleteClick(type === 'jv' ? item : item.id);
//                                        }}
//                                        className={`p-1.5 sm:p-2 rounded-lg transition-all duration-200 transform hover:scale-110 ${
//                                           isDark
//                                              ? 'text-rose-400 hover:bg-rose-500/20 hover:text-rose-300 hover:shadow-lg hover:shadow-rose-500/20'
//                                              : 'text-rose-600 hover:bg-rose-100 hover:text-rose-700 hover:shadow-md hover:shadow-rose-200/50'
//                                        } focus:outline-none focus:ring-2 focus:ring-rose-500/40`}>
//                                        <DeleteIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
//                                     </button>
//                                  )}
//                            </div>
//                         </div>
//                      )}

//                   {/* Data Columns - Now with controlled click handling */}
//                   <div className="flex-1 cursor-pointer" onClick={handleRowClick}>
//                      <div className="flex items-center overflow-x-auto scrollbar-hide">
//                         {columnsData
//                            ?.filter((column) => columnVisibility[column.id])
//                            ?.map((column) => (
//                               <div key={column.id} className="flex-1 px-2 min-w-[100px] sm:min-w-[120px] md:min-w-0">
//                                  {column.id === 'amt' ? (
//                                     <span
//                                        className={`inline-flex items-center justify-center font-semibold w-32 text-xs sm:text-sm inline-block px-2 sm:px-3 py-1 rounded-lg ${
//                                           item.amt < 0
//                                              ? isDark
//                                                 ? 'text-emerald-400 bg-emerald-500/15 border border-emerald-500/30'
//                                                 : 'text-emerald-700 bg-gradient-to-br from-emerald-50 to-emerald-100/50 border border-emerald-300'
//                                              : isDark
//                                              ? 'text-rose-400 bg-rose-500/15 border border-rose-500/30'
//                                              : 'text-rose-700 bg-gradient-to-br from-rose-50 to-rose-100/50 border border-rose-300'
//                                        }`}>
//                                        {formatBalance(item.amt).text}
//                                     </span>
//                                  ) : column.id === 'status' ? (
//                                     <div className="px-3" onClick={(e) => e.stopPropagation()}>
//                                        <StatusSwitch
//                                           isActive={item.status}
//                                           cityId={item.id}
//                                           onStatusChange={onStatusChange}
//                                        />
//                                     </div>
//                                  ) : column.id === 'globalImeiStatus' ? (
//                                     <span
//                                        className={`inline-block px-2.5 sm:px-3 py-1 rounded-lg font-semibold text-xs sm:text-sm shadow-sm ${
//                                           getStatusText(item.globalImeiStatus).className
//                                        }`}>
//                                        {getStatusText(item.globalImeiStatus).text}
//                                     </span>
//                                  ) : column.id === 'amount' ? (
//                                     <span
//                                        className={`inline-flex items-center justify-center w-full px-2.5 sm:px-3 py-1 rounded-lg border-2 font-semibold text-xs sm:text-sm shadow-sm transition-all duration-200 ${
//                                           item.txnType === 1
//                                              ? isDark
//                                                 ? 'border-rose-500/50 text-rose-400 bg-rose-500/10 hover:bg-rose-500/20'
//                                                 : 'border-rose-400 text-rose-700 bg-gradient-to-br from-rose-50 to-rose-100/50 hover:from-rose-100 hover:to-rose-200/50'
//                                              : isDark
//                                              ? 'border-emerald-500/50 text-emerald-400 bg-emerald-500/10 hover:bg-emerald-500/20'
//                                              : 'border-emerald-400 text-emerald-700 bg-gradient-to-br from-emerald-50 to-emerald-100/50 hover:from-emerald-100 hover:to-emerald-200/50'
//                                        }`}>
//                                        {formatAmountWithLabel(item.amount)}&nbsp;{item.txnType === 1 ? 'CR' : 'DB'}
//                                     </span>
//                                  ) : isDateField(column.id, item[column.id]) ? (
//                                     <span
//                                        className={`text-xs sm:text-sm font-medium ${
//                                           isDark ? 'text-slate-300' : 'text-gray-700'
//                                        }`}>
//                                        {formatDate(item[column.id])}
//                                     </span>
//                                  ) : (
//                                     <span
//                                        className={`text-xs sm:text-sm font-medium ${
//                                           isDark ? 'text-slate-300' : 'text-gray-700'
//                                        }`}>
//                                        {item[column.id]}
//                                     </span>
//                                  )}
//                               </div>
//                            ))}
//                      </div>
//                   </div>
//                </div>
//             </div>
//          </div>
//       );
//    });

//    // Header row component
//    const HeaderRow = memo(({ columnsData, columnVisibility, selectedRows, onSelectAll, totalItems }) => (
//       <div
//          className={`flex items-center px-4 py-2 border-b-2 font-semibold sticky top-0 z-10 backdrop-blur-sm ${
//             isDark
//                ? 'bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 border-slate-700/80 text-slate-100 shadow-lg shadow-slate-900/50'
//                : 'bg-gradient-to-r from-white via-blue-50/30 to-white border-gray-300/80 text-gray-800 shadow-md'
//          }`}>
//          {/* Checkbox Column Header */}
//          <div className="flex-none w-12 sm:w-14 md:w-16 px-1 sm:px-2">
//             <input
//                type="checkbox"
//                checked={selectedRows.length > 0 && selectedRows.length === totalItems}
//                ref={(input) => {
//                   if (input) input.indeterminate = selectedRows.length > 0 && selectedRows.length < totalItems;
//                }}
//                onChange={onSelectAll}
//                className={`w-4 h-4 rounded-md transition-all duration-200 cursor-pointer ${
//                   isDark
//                      ? 'bg-slate-800 border-slate-600 text-blue-500 focus:ring-blue-500/40 focus:ring-offset-slate-900'
//                      : 'bg-white border-gray-400 text-blue-600 focus:ring-blue-500/40 focus:ring-offset-white'
//                } focus:ring-2 focus:ring-offset-2 hover:border-blue-400`}
//             />
//          </div>

//          {/* Actions Column Header */}
//          {!['city', 'state', 'country'].includes(type?.toLowerCase()) &&
//             (type === 'cash' || type === 'bank' || (user && !user.isExpired)) && (
//                <div className="flex-none w-24 sm:w-28 md:w-32 lg:w-36 px-1 sm:px-2 text-left">
//                   <span className="text-xs sm:text-sm font-bold tracking-wide uppercase">Actions</span>
//                </div>
//             )}

//          {/* Data Column Headers */}
//          <div className="flex-1">
//             <div className="flex items-center overflow-x-auto scrollbar-hide">
//                {columnsData
//                   ?.filter((column) => columnVisibility[column.id])
//                   ?.map((column) => (
//                      <div key={column.id} className="flex-1 px-2 min-w-[100px] sm:min-w-[120px] md:min-w-0">
//                         <span className="text-xs sm:text-sm font-bold tracking-wide uppercase">{column.header}</span>
//                      </div>
//                   ))}
//             </div>
//          </div>
//       </div>
//    ));

//    const Admin = user?.isAdmin || false;

//    const [hasMore, setHasMore] = useState(true);
//    const [selectedRows, setSelectedRows] = useState([]);
//    const [isLoadingMore, setIsLoadingMore] = useState(false);
//    const isLoading = useSelector((state) => state.item?.loading || false);
//    const dispatch = useDispatch();

//    const listRef = useRef();
//    const heightMap = new Map();

//    // Check if there are more items to load
//    useEffect(() => {
//       setHasMore(data.length < totalCount);
//    }, [data.length, totalCount]);

//    const loadMoreItems = useCallback(
//       async (startIndex, stopIndex) => {
//          if (isLoadingMore || !hasMore || !fetchMoreData) return;

//          console.log('Loading more items:', { startIndex, stopIndex, currentLength: data.length });

//          setIsLoadingMore(true);
//          try {
//             const page = Math.floor(data.length / limit) + 1;
//             await fetchMoreData(page);
//          } catch (error) {
//             console.error('Error loading more items:', error);
//          } finally {
//             setIsLoadingMore(false);
//          }
//       },
//       [data.length, limit, hasMore, isLoadingMore, fetchMoreData],
//    );

//    const isItemLoaded = useCallback(
//       (index) => {
//          // If we're loading more items, show skeleton for items beyond current data
//          return index < data.length;
//       },
//       [data.length],
//    );

//    const handleRowSelect = useCallback((id) => {
//       setSelectedRows((prev) => {
//          if (prev.includes(id)) {
//             return prev?.filter((rowId) => rowId !== id);
//          } else {
//             return [...prev, id];
//          }
//       });
//    }, []);

//    const ActionBar = {
//       Root: ({ open, children }) => (open ? children : null),
//       Positioner: ({ children }) => (
//          <div className="fixed bottom-4 sm:bottom-6 left-0 right-0 flex justify-center px-4 z-50">{children}</div>
//       ),
//       Content: ({ children }) => (
//          <div
//             className={`flex flex-wrap items-center gap-2 sm:gap-4 px-4 sm:px-6 py-3 rounded-2xl shadow-2xl max-w-[95%] sm:max-w-[90%] w-auto backdrop-blur-xl transition-all duration-300 border-2 ${
//                isDark
//                   ? 'bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 border-slate-700/70 shadow-slate-950/80'
//                   : 'bg-gradient-to-br from-white via-blue-50/30 to-white border-gray-300 shadow-gray-400/50'
//             }`}>
//             {children}
//          </div>
//       ),
//       SelectionTrigger: ({ children }) => (
//          <span className={`font-bold text-sm ${isDark ? 'text-slate-100' : 'text-gray-800'}`}>{children}</span>
//       ),
//       Separator: () => <div className={`h-6 w-px mx-1 ${isDark ? 'bg-slate-600' : 'bg-gray-400'}`} />,
//    };

//    const selectedCount = selectedRows.length;

//    const handleMultiDelete = () => {
//       if (selectedRows.length > 0 && onMultiDeleteClick) {
//          onMultiDeleteClick(selectedRows);
//          clearSelections();
//       }
//    };

//    const clearSelections = () => {
//       setSelectedRows([]);
//    };

//    const handleEditClick = useCallback((row) => {
//       setCurrentRow(row);
//       setIsEditMode(true);
//       onOpen();
//       if (emptyMessage !== 'No Journal voucher data found' && emptyMessage !== 'No IMEI data found') {
//          setIsOpenSingleView(false);
//       }
//    }, []);

//    const handleDeleteClick = useCallback((id) => {
//       if (type === 'cash' || type === 'bank') {
//          onDeleteClick(id);
//       } else {
//          setSelectedRowId(id);
//          setDeleteDialogOpen(true);
//       }
//    }, []);

//    const handleSelectAll = useCallback(() => {
//       if (selectedRows.length === data.length) {
//          setSelectedRows([]);
//       } else {
//          setSelectedRows(data.map((item) => item.id));
//       }
//    }, [selectedRows.length, data]);

//    const getItemSize = (index) => {
//       return heightMap.get(index) || 60;
//    };

//    const setSize = (index, size) => {
//       if (heightMap.get(index) !== size) {
//          heightMap.set(index, size);
//          listRef.current?.resetAfterIndex(index);
//       }
//    };

//    const itemData = useMemo(
//       () => ({
//          items: data,
//          columnVisibility,
//          columnsData,
//          Admin,
//          right,
//          receiveRight,
//          paymentRight,
//          handleViewSingleData,
//          onDeleteClick: handleDeleteClick,
//          onEditClick: handleEditClick,
//          customerRight: right,
//          selectedRows,
//          onRowSelect: handleRowSelect,
//          onStatusChange: handleStatusChange,
//          onLogClick,
//          type,
//          setSize,
//          isAbs,
//       }),
//       [
//          data,
//          columnVisibility,
//          columnsData,
//          Admin,
//          right,
//          receiveRight,
//          paymentRight,
//          handleViewSingleData,
//          handleDeleteClick,
//          handleEditClick,
//          selectedRows,
//          handleRowSelect,
//          handleStatusChange,
//          onLogClick,
//          type,
//          setSize,
//          isAbs,
//       ],
//    );

//    const shouldShowMultiDelete = useMemo(() => {
//       if (selectedCount === 0) return false;

//       // If user is Admin, they can delete anything - no further checks needed
//       if (Admin) return true;

//       // For non-admin users, check basic delete permission
//       if (!right?.deleteRole) return false;

//       const selectedItems = data.filter((item) => selectedRows.includes(item.id));

//       // For cash and bank types, check transaction-specific rights
//       if (type === 'cash' || type === 'bank') {
//          return selectedItems.every((item) => {
//             if (item?.txnType === 0) {
//                return receiveRight?.deleteRole;
//             } else if (item?.txnType === 1) {
//                return paymentRight?.deleteRole;
//             }
//             return true;
//          });
//       }

//       // For city, state, country types - no userCode check needed
//       if (['city', 'state', 'country'].includes(type?.toLowerCase())) {
//          return true;
//       }

//       // For Unit and Group entity types, check usercode/userCode
//       return selectedItems.every((item) => {
//          if (entityType === 'Unit') {
//             return !!item?.usercode;
//          }
//          if (entityType === 'Group') {
//             return !!item?.userCode;
//          }
//          // For other entity types or undefined entityType, allow deletion
//          return true;
//       });
//    }, [
//       selectedCount,
//       Admin,
//       right?.deleteRole,
//       receiveRight?.deleteRole,
//       paymentRight?.deleteRole,
//       entityType,
//       type,
//       data,
//       selectedRows,
//    ]);

//    return (
//       <div
//          className={`h-[700px] w-full overflow-hidden shadow-2xl transition-all duration-300 border-2 ${
//             isDark
//                ? 'bg-slate-900/90 border-slate-800/80 shadow-slate-950/50'
//                : 'bg-white border-gray-300/80 shadow-gray-300/50'
//          }`}>
//          {/* Table Header */}
//          <HeaderRow
//             columnsData={columnsData}
//             columnVisibility={columnVisibility}
//             selectedRows={selectedRows}
//             onSelectAll={handleSelectAll}
//             totalItems={data.length}
//          />

//          {/* Table Body with Virtual Scrolling */}
//          {data.length === 0 && !isLoading ? (
//             <div className="flex items-center justify-center p-8 h-full">
//                <div className="text-center">
//                   <p className={`text-lg font-semibold ${isDark ? 'text-slate-300' : 'text-gray-700'}`}>
//                      {emptyMessage || 'No data found'}
//                   </p>
//                </div>
//             </div>
//          ) : (
//             <div className="h-[calc(100%-60px)]">
//                <InfiniteLoader
//                   isItemLoaded={isItemLoaded}
//                   itemCount={hasMore ? data.length + 10 : data.length}
//                   loadMoreItems={loadMoreItems}
//                   minimumBatchSize={10}
//                   threshold={3}>
//                   {({ onItemsRendered, ref }) => (
//                      <List
//                         ref={(list) => {
//                            listRef.current = list;
//                            ref(list);
//                         }}
//                         height={650}
//                         itemCount={hasMore ? data.length + 10 : data.length}
//                         itemSize={getItemSize}
//                         itemData={itemData}
//                         onItemsRendered={onItemsRendered}
//                         overscanCount={5}>
//                         {VirtualRow}
//                      </List>
//                   )}
//                </InfiniteLoader>

//                {/* Action Bar */}
//                <ActionBar.Root open={shouldShowMultiDelete}>
//                   <ActionBar.Positioner>
//                      <ActionBar.Content>
//                         <ActionBar.SelectionTrigger>
//                            <span
//                               className={`inline-flex items-center justify-center w-7 h-7 rounded-full mr-2 text-xs font-bold shadow-lg ${
//                                  isDark
//                                     ? 'bg-gradient-to-br from-blue-500 to-blue-600 text-white'
//                                     : 'bg-gradient-to-br from-blue-500 to-blue-600 text-white'
//                               }`}>
//                               {selectedCount}
//                            </span>
//                            selected
//                         </ActionBar.SelectionTrigger>
//                         <ActionBar.Separator />
//                         <button
//                            onClick={clearSelections}
//                            className={`p-2 rounded-lg transition-all duration-200 transform hover:scale-110 ${
//                               isDark
//                                  ? 'text-slate-300 hover:bg-slate-700 hover:text-slate-100'
//                                  : 'text-gray-600 hover:bg-gray-100 hover:text-gray-800'
//                            }`}>
//                            <CloseIcon className="w-4 h-4" />
//                         </button>
//                         {user && !user.isExpired && (
//                            <button
//                               onClick={handleMultiDelete}
//                               className={`flex items-center gap-2 px-4 py-2 rounded-lg font-bold text-sm transition-all duration-200 transform hover:scale-105 shadow-lg ${
//                                  isDark
//                                     ? 'text-rose-400 border-2 border-rose-500/50 hover:bg-rose-500/20 hover:border-rose-500/70 hover:shadow-rose-500/30'
//                                     : 'text-rose-700 border-2 border-rose-400 hover:bg-rose-100 hover:border-rose-500 hover:shadow-rose-300/50'
//                               }`}>
//                               <DeleteIcon className="w-4 h-4" />
//                               Delete
//                            </button>
//                         )}
//                      </ActionBar.Content>
//                   </ActionBar.Positioner>
//                </ActionBar.Root>
//             </div>
//          )}
//       </div>
//    );
// };

// export default DynamicTable;

import React, { useState, useEffect, useRef, memo, useCallback, useMemo } from 'react';
import { Text, useColorMode } from '@chakra-ui/react';
import { VariableSizeList as List } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';
import { useDispatch, useSelector } from 'react-redux';
import { useUser } from 'contexts';
import { DeleteIcon, EditIcon, CloseIcon, InfoIcon } from '@chakra-ui/icons';

// Date formatting utility function
const formatDate = (dateString) => {
   if (!dateString) return '-';

   try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '-';

      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
   } catch (error) {
      return '-';
   }
};

// Check if a field is likely a date field
const isDateField = (fieldName, value) => {
   const dateFields = ['date', 'createdAt', 'updatedAt', 'transactionAt', 'txnDate'];

   const isDateFieldName = dateFields.some((field) => fieldName.toLowerCase().includes(field.toLowerCase()));
   const isDateValue =
      typeof value === 'string' && (/^\d{4}-\d{2}-\d{2}/.test(value) || /^\d{2}\/\d{2}\/\d{4}/.test(value));

   return isDateFieldName || isDateValue;
};

const formatBalance = (value) => {
   const numValue = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : Number(value);
   if (isNaN(numValue)) {
      return {
         text: (
            <>
               0
               <Text fontSize={{ base: '9px', md: '10px' }} mt={0.5}>
                  .00
               </Text>{' '}
               CR
            </>
         ),
         color: 'red.500',
      };
   }
   const isNegative = numValue < 0;
   const absValue = Math.abs(numValue);
   const formatted = absValue.toFixed(2);
   const [integerPart, decimalPart] = formatted.split('.');
   const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

   return {
      text: (
         <>
            {formattedInteger}
            <Text fontSize={{ base: '9px', md: '10px' }} mt={0.5} mr={0.5}>
               .{decimalPart}
            </Text>
            {isNegative ? 'DB' : 'CR'}
         </>
      ),
      color: isNegative ? 'green.500' : 'red.500',
   };
};

const formatAmountWithLabel = (value) => {
   const numValue = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : Number(value);

   if (isNaN(numValue)) {
      return (
         <>
            0
            <Text as="span" fontSize={{ base: '9px', md: '10px' }}>
               .00
            </Text>
         </>
      );
   }

   const absValue = Math.abs(numValue);
   const formatted = absValue.toFixed(2);
   const [integerPart, decimalPart] = formatted.split('.');
   const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

   return (
      <>
         {formattedInteger}
         <Text as="span" fontSize={{ base: '9px', md: '10px' }} mt={0.5}>
            .{decimalPart}
         </Text>
      </>
   );
};

const DynamicTable = ({
   data,
   right,
   receiveRight,
   paymentRight,
   handleViewSingleData,
   handleStatusChange,
   columnVisibility,
   pagename = true,
   columnsData,
   sorting,
   limit = 20,
   setCurrentRow,
   onOpen,
   setIsEditMode,
   setIsOpenSingleView,
   setDeleteDialogOpen,
   onDeleteClick,
   onMultiDeleteClick,
   setSelectedRowId,
   debouncedSearchQuery,
   totalCount,
   type,
   entityType,
   emptyMessage,
   onLogClick,
   fetchMoreData,
   isAbs = false,
}) => {
   const { user } = useUser();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   const StatusSwitch = memo(({ isActive, cityId, onStatusChange, isDisabled = false }) => {
      const [isLoading, setIsLoading] = useState(false);

      const handleStatusToggle = async () => {
         if (isDisabled) return;

         setIsLoading(true);
         try {
            const newStatus = !isActive;
            await onStatusChange(cityId, newStatus);
            setIsOpenSingleView(false);
         } catch (error) {
            console.error('Failed to update status');
         } finally {
            setIsLoading(false);
         }
      };

      return (
         <div className="flex items-center gap-2">
            <button
               onClick={handleStatusToggle}
               disabled={isDisabled || isLoading}
               className={`relative inline-flex h-6 w-11 items-center rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 shadow-sm ${
                  isActive
                     ? 'bg-gradient-to-r from-emerald-500 to-emerald-600 focus:ring-emerald-500'
                     : isDark
                     ? 'bg-slate-700 focus:ring-slate-500'
                     : 'bg-gray-300 focus:ring-gray-400'
               } ${isDisabled || isLoading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:shadow-md'}`}>
               <span
                  className={`inline-block h-4 w-4 transform rounded-full bg-white shadow-lg transition-transform duration-300 ${
                     isActive ? 'translate-x-6' : 'translate-x-1'
                  }`}
               />
            </button>
            {isLoading && <div className="text-xs text-gray-500">Updating...</div>}
         </div>
      );
   });

   const Admin = user?.isAdmin || false;
   const [hasMore, setHasMore] = useState(true);
   const [selectedRows, setSelectedRows] = useState([]);
   const [isLoadingMore, setIsLoadingMore] = useState(false);
   const isLoading = useSelector((state) => state.item?.loading || false);
   const headerScrollRef = useRef();
   const listRef = useRef();
   const heightMap = useRef(new Map());
   const containerRef = useRef(null);
   const [containerWidth, setContainerWidth] = useState(0);

   const callbacksRef = useRef({
      handleViewSingleData,
      setCurrentRow,
      setIsEditMode,
      onOpen,
      setIsOpenSingleView,
      setDeleteDialogOpen,
      onDeleteClick,
      setSelectedRowId,
      onLogClick,
      handleStatusChange,
   });

   // Update ref when callbacks change
   useEffect(() => {
      callbacksRef.current = {
         handleViewSingleData,
         setCurrentRow,
         setIsEditMode,
         onOpen,
         setIsOpenSingleView,
         setDeleteDialogOpen,
         onDeleteClick,
         setSelectedRowId,
         onLogClick,
         handleStatusChange,
      };
   }, [
      handleViewSingleData,
      setCurrentRow,
      setIsEditMode,
      onOpen,
      setIsOpenSingleView,
      setDeleteDialogOpen,
      onDeleteClick,
      setSelectedRowId,
      onLogClick,
      handleStatusChange,
   ]);

   useEffect(() => {
      const updateWidth = () => {
         if (containerRef.current) {
            setContainerWidth(containerRef.current.offsetWidth);
         }
      };

      updateWidth();
      window.addEventListener('resize', updateWidth);
      return () => window.removeEventListener('resize', updateWidth);
   }, []);

   useEffect(() => {
      setHasMore(data.length < totalCount);
   }, [data.length, totalCount]);
   // Add this after your other useEffects
   useEffect(() => {
      const listElement = listRef.current?._outerRef;
      if (!listElement || !headerScrollRef.current) return;

      const handleListScroll = () => {
         if (headerScrollRef.current) {
            headerScrollRef.current.scrollLeft = listElement.scrollLeft;
         }
      };

      listElement.addEventListener('scroll', handleListScroll);
      return () => listElement.removeEventListener('scroll', handleListScroll);
   }, []);

   const handleHeaderScroll = useCallback(() => {
      const listElement = listRef.current?._outerRef;
      if (headerScrollRef.current && listElement) {
         listElement.scrollLeft = headerScrollRef.current.scrollLeft;
      }
   }, []);

   // Calculate column widths dynamically based on content and header
   const calculateColumnWidth = useCallback(
      (column) => {
         // Base width from header length
         const headerLength = column.header?.length || 10;
         let width = Math.max(120, headerLength * 8 + 40);

         // Check column width from first few rows
         if (data.length > 0) {
            const sampleSize = Math.min(5, data.length);
            for (let i = 0; i < sampleSize; i++) {
               const value = data[i]?.[column.id];
               if (value) {
                  const valueLength = String(value).length;
                  width = Math.max(width, valueLength * 7 + 40);
               }
            }
         }

         // Max width cap
         return Math.min(width, 300);
      },
      [data],
   );

   // Memoize column widths
   const columnWidths = useMemo(() => {
      const widths = {};
      columnsData?.forEach((column) => {
         widths[column.id] = calculateColumnWidth(column);
      });
      return widths;
   }, [columnsData, calculateColumnWidth]);

   const showActionsColumn =
      !['city', 'state', 'country'].includes(type?.toLowerCase()) &&
      ((user && !user.isExpired) || type === 'cash' || type === 'bank');

   const visibleColumns = columnsData?.filter((column) => columnVisibility[column.id]) || [];

   // Total width for table
   const totalWidth = useMemo(() => {
      const checkboxWidth = 48;
      const actionsWidth = showActionsColumn ? 140 : 0;

      const columnsWidth = visibleColumns.reduce((total, col) => {
         return total + (columnWidths[col.id] || 150);
      }, 0);

      const calculatedWidth = checkboxWidth + actionsWidth + columnsWidth;

      // Always return at least container width to fill the space
      return Math.max(calculatedWidth, containerWidth || 1000);
   }, [visibleColumns, columnWidths, showActionsColumn, containerWidth]);

   // Check if columns should be flexible (when content is less than container)
   const shouldUseFlexColumns = useMemo(() => {
      const checkboxWidth = 48;
      const actionsWidth = showActionsColumn ? 140 : 0;

      const columnsWidth = visibleColumns.reduce((total, col) => {
         return total + (columnWidths[col.id] || 150);
      }, 0);

      const calculatedWidth = checkboxWidth + actionsWidth + columnsWidth;
      return calculatedWidth < (containerWidth || 1000);
   }, [visibleColumns, columnWidths, showActionsColumn, containerWidth]);

   const SkeletonRow = memo(({ style }) => {
      return (
         <div style={{ ...style, width: '100%', minWidth: totalWidth }}>
            <div
               className={`flex items-center border-b animate-pulse ${
                  isDark ? 'border-slate-800/80 bg-slate-900/40' : 'border-gray-200/60 bg-gray-50/40'
               }`}
               style={{ height: '60px' }}>
               <div className="flex-shrink-0 flex items-center justify-center" style={{ width: '48px' }}>
                  <div className={`w-4 h-4 rounded-md ${isDark ? 'bg-slate-700' : 'bg-gray-300'}`} />
               </div>

               {showActionsColumn && (
                  <div className="flex-shrink-0 flex items-center justify-start px-2" style={{ width: '140px' }}>
                     <div className="flex gap-1.5">
                        <div className={`w-8 h-8 rounded-lg ${isDark ? 'bg-slate-700' : 'bg-gray-300'}`} />
                        <div className={`w-8 h-8 rounded-lg ${isDark ? 'bg-slate-700' : 'bg-gray-300'}`} />
                        <div className={`w-8 h-8 rounded-lg ${isDark ? 'bg-slate-700' : 'bg-gray-300'}`} />
                     </div>
                  </div>
               )}

               {visibleColumns.map((column, idx) => (
                  <div
                     key={idx}
                     className={
                        shouldUseFlexColumns ? 'flex-1 px-3 flex items-center' : 'flex-shrink-0 px-3 flex items-center'
                     }
                     style={
                        shouldUseFlexColumns
                           ? { minWidth: `${columnWidths[column.id]}px` }
                           : { width: `${columnWidths[column.id]}px` }
                     }>
                     <div
                        className={`h-5 rounded ${isDark ? 'bg-slate-700' : 'bg-gray-300'}`}
                        style={{ width: `${60 + Math.random() * 40}%` }}
                     />
                  </div>
               ))}
            </div>
         </div>
      );
   });

   const VirtualRow = memo(({ index, style, data: rowData }) => {
      const logIconShow = type === 'cash' || type === 'bank';

      const getStatusText = (status) => {
         switch (status) {
            case 0:
               return {
                  text: 'Pending',
                  className: isDark
                     ? 'text-amber-400 bg-amber-500/10 border border-amber-500/40'
                     : 'text-amber-700 bg-amber-50 border border-amber-300',
               };
            case 1:
               return {
                  text: 'Approved',
                  className: isDark
                     ? 'text-emerald-400 bg-emerald-500/10 border border-emerald-500/40'
                     : 'text-emerald-700 bg-emerald-50 border border-emerald-300',
               };
            case 2:
               return {
                  text: 'Rejected',
                  className: isDark
                     ? 'text-rose-400 bg-rose-500/10 border border-rose-500/40'
                     : 'text-rose-700 bg-rose-50 border border-rose-300',
               };
            default:
               return { text: '', className: '' };
         }
      };

      const ref = useRef();
      const {
         items,
         columnVisibility,
         columnsData,
         onDeleteClick,
         onEditClick,
         selectedRows,
         onRowSelect,
         Admin,
         right,
         receiveRight,
         paymentRight,
         setSize,
         onStatusChange,
         onLogClick,
         isAbs,
         showActionsColumn,
         totalWidth,
         columnWidths,
         shouldUseFlexColumns,
         onRowClick,
      } = rowData;
      const item = items[index];
      const isAbsItem = item?.isAbs;

      useEffect(() => {
         if (ref.current) {
            heightMap.current.set(index, ref.current.getBoundingClientRect().height);
            listRef.current?.resetAfterIndex(index);
         }
      }, [index, item]);

      if (!item) {
         return <SkeletonRow style={style} />;
      }

      const handleRowClick = (e) => {
         if (e.target.closest('button') || e.target.closest('input')) {
            return;
         }
         onRowClick?.(item);
      };

      const handleEdit = (e) => {
         e.stopPropagation();
         onEditClick?.(item);
      };

      const handleDelete = (e) => {
         e.stopPropagation();
         onDeleteClick?.(item);
      };

      const handleLog = (e) => {
         e.stopPropagation();
         onLogClick?.(item);
      };

      const visibleColumns = columnsData?.filter((column) => columnVisibility[column.id]) || [];

      return (
         <div style={{ ...style, width: '100%', minWidth: totalWidth }}>
            <div
               ref={ref}
               onClick={handleRowClick}
               className={`flex items-center border-b transition-colors cursor-pointer  ${
                  isDark ? 'border-slate-800/80 hover:bg-slate-800/60' : 'border-gray-200 hover:bg-blue-50/40'
               } ${
                  selectedRows.includes(item.id)
                     ? isDark
                        ? 'bg-blue-500/10 border-blue-500/30'
                        : 'bg-blue-50/70 border-blue-300/50'
                     : ''
               }`}
               style={{ minHeight: '60px' }}>
               {!isAbsItem && (
                  <div className="flex-shrink-0 flex items-center justify-center" style={{ width: '48px' }}>
                     <input
                        type="checkbox"
                        checked={selectedRows.includes(item.id)}
                        onChange={(e) => {
                           e.stopPropagation();
                           onRowSelect(item.id);
                        }}
                        className={`w-4 h-4 rounded-md transition-all cursor-pointer ${
                           isDark
                              ? 'bg-slate-800 border-slate-600 text-blue-500 focus:ring-blue-500/40'
                              : 'bg-white border-gray-300 text-blue-600 focus:ring-blue-500/40'
                        } focus:ring-2`}
                     />
                  </div>
               )}

               {/* Show empty space for checkbox column when isAbs */}
               {isAbsItem && <div className="flex-shrink-0" style={{ width: '48px' }}></div>}

               {/* Actions */}
               {showActionsColumn && (
                  <div className="flex-shrink-0 flex items-center justify-start px-2" style={{ width: '140px' }}>
                     <div className="flex gap-2">
                        {logIconShow && onLogClick && (
                           <button
                              onClick={handleLog}
                              className={`p-2 rounded-lg transition-all ${
                                 isDark ? 'text-blue-400 hover:bg-blue-500/20' : 'text-blue-600 hover:bg-blue-100'
                              }`}>
                              <InfoIcon className="w-4 h-4" />
                           </button>
                        )}

                        {(Admin ||
                           (type === 'cash' || type === 'bank'
                              ? item?.txnType === 0
                                 ? receiveRight?.edit
                                 : item?.txnType === 1
                                 ? paymentRight?.edit
                                 : true
                              : right?.edit)) &&
                           (entityType === 'Unit' ? item?.usercode : true) &&
                           (entityType === 'Group' ? item?.userCode : true) &&
                           user &&
                           !user.isExpired && (
                              <button
                                 onClick={handleEdit}
                                 className={`p-2 rounded-lg transition-all ${
                                    isDark
                                       ? 'text-emerald-400 hover:bg-emerald-500/20'
                                       : 'text-emerald-600 hover:bg-emerald-100'
                                 }`}>
                                 <EditIcon className="w-4 h-4" />
                              </button>
                           )}

                        {(Admin ||
                           (type === 'cash' || type === 'bank'
                              ? item?.txnType === 0
                                 ? receiveRight?.deleteRole
                                 : item?.txnType === 1
                                 ? paymentRight?.deleteRole
                                 : true
                              : right?.deleteRole)) &&
                           (entityType === 'Unit' ? item?.usercode : true) &&
                           (entityType === 'Group' ? item?.userCode : true) &&
                           user &&
                           !user.isExpired &&
                           !item?.isAbs && (
                              <button
                                 onClick={handleDelete}
                                 className={`p-2 rounded-lg transition-all ${
                                    isDark ? 'text-rose-400 hover:bg-rose-500/20' : 'text-rose-600 hover:bg-rose-100'
                                 }`}>
                                 <DeleteIcon className="w-4 h-4" />
                              </button>
                           )}
                     </div>
                  </div>
               )}

               {/* Data Columns */}
               {visibleColumns.map((column) => (
                  <div
                     key={column.id}
                     className={`px-3 flex items-center ${shouldUseFlexColumns ? 'flex-1' : 'flex-shrink-0'}`}
                     style={
                        shouldUseFlexColumns
                           ? { minWidth: `${columnWidths[column.id]}px` }
                           : { width: `${columnWidths[column.id]}px` }
                     }>
                     {column.id === 'amt' ? (
                        <span
                           className={`inline-flex items-center w-full justify-center font-semibold text-xs px-2 py-1 rounded-lg border whitespace-nowrap ${
                              item.amt < 0
                                 ? isDark
                                    ? 'text-emerald-400 bg-emerald-500/15 border-emerald-500/30'
                                    : 'text-emerald-700 bg-emerald-50 border-emerald-300'
                                 : isDark
                                 ? 'text-rose-400 bg-rose-500/15 border-rose-500/30'
                                 : 'text-rose-700 bg-rose-50 border-rose-300'
                           }`}>
                           {formatBalance(item.amt).text}
                        </span>
                     ) : column.id === 'status' ? (
                        <div onClick={(e) => e.stopPropagation()}>
                           <StatusSwitch isActive={item.status} cityId={item.id} onStatusChange={onStatusChange} />
                        </div>
                     ) : column.id === 'globalImeiStatus' ? (
                        <span
                           className={`inline-block w-48 text-center px-2 py-1 rounded-lg font-semibold text-xs whitespace-nowrap ${
                              getStatusText(item.globalImeiStatus).className
                           }`}>
                           {getStatusText(item.globalImeiStatus).text}
                        </span>
                     ) : column.id === 'amount' ? (
                        <span
                           className={`inline-flex items-center justify-center w-full px-2 py-1 rounded-lg border font-semibold text-xs whitespace-nowrap ${
                              item.txnType === 1
                                 ? isDark
                                    ? 'border-rose-500/50 text-rose-400 bg-rose-500/10'
                                    : 'border-rose-400 text-rose-700 bg-rose-50'
                                 : isDark
                                 ? 'border-emerald-500/50 text-emerald-400 bg-emerald-500/10'
                                 : 'border-emerald-400 text-emerald-700 bg-emerald-50'
                           }`}>
                           {formatAmountWithLabel(item.amount)}&nbsp;
                           {item.txnType === 1 ? 'CR' : 'DB'}
                        </span>
                     ) : isDateField(column.id, item[column.id]) ? (
                        <span
                           className={`text-xs font-medium truncate block ${
                              isDark ? 'text-slate-300' : 'text-gray-700'
                           }`}
                           title={formatDate(item[column.id])}>
                           {formatDate(item[column.id])}
                        </span>
                     ) : (
                        <span
                           className={`text-[13px] font-medium truncate block ${isDark ? 'text-white' : 'text-black'}`}
                           title={item[column.id]}>
                           {item[column.id] || '-'}
                        </span>
                     )}
                  </div>
               ))}
            </div>
         </div>
      );
   });

   const HeaderRow = memo(
      ({
         columnsData,
         columnVisibility,
         selectedRows,
         onSelectAll,
         totalItems,
         showActionsColumn,
         totalWidth,
         columnWidths,
         shouldUseFlexColumns,
      }) => {
         const visibleColumns = columnsData?.filter((column) => columnVisibility[column.id]) || [];

         return (
            <div
               className={`flex items-center border-b-2 font-semibold text-xs uppercase tracking-wide ${
                  isDark ? 'bg-slate-900 border-slate-700 text-slate-100' : 'bg-white border-gray-300 text-gray-800'
               }`}
               style={{ height: '50px', width: '100%', minWidth: totalWidth, position: 'sticky', top: 0, zIndex: 10 }}>
               <div className="flex-shrink-0 flex items-center justify-center" style={{ width: '48px' }}>
                  <input
                     type="checkbox"
                     checked={selectedRows.length > 0 && selectedRows.length === totalItems}
                     ref={(input) => {
                        if (input) input.indeterminate = selectedRows.length > 0 && selectedRows.length < totalItems;
                     }}
                     onChange={onSelectAll}
                     className={`w-4 h-4 rounded-md cursor-pointer ${
                        isDark
                           ? 'bg-slate-800 border-slate-600 text-blue-500'
                           : 'bg-white border-gray-400 text-blue-600'
                     }`}
                  />
               </div>

               {showActionsColumn && (
                  <div className="flex-shrink-0 flex items-center justify-start px-2" style={{ width: '140px' }}>
                     Actions
                  </div>
               )}

               {visibleColumns.map((column) => (
                  <div
                     key={column.id}
                     className={`px-3 flex items-center ${shouldUseFlexColumns ? 'flex-1' : 'flex-shrink-0'}`}
                     style={
                        shouldUseFlexColumns
                           ? { minWidth: `${columnWidths[column.id]}px` }
                           : { width: `${columnWidths[column.id]}px` }
                     }>
                     <span className="truncate block" title={column.header}>
                        {column.header}
                     </span>
                  </div>
               ))}
            </div>
         );
      },
   );

   useEffect(() => {
      setHasMore(data.length < totalCount);
   }, [data.length, totalCount]);

   const loadMoreItems = useCallback(
      async (startIndex, stopIndex) => {
         if (isLoadingMore || !hasMore || !fetchMoreData) return;

         setIsLoadingMore(true);
         try {
            const page = Math.floor(data.length / limit) + 1;
            await fetchMoreData(page);
         } catch (error) {
            console.error('Error loading more items:', error);
         } finally {
            setIsLoadingMore(false);
         }
      },
      [data.length, limit, hasMore, isLoadingMore, fetchMoreData],
   );

   const isItemLoaded = useCallback((index) => index < data.length, [data.length]);

   const handleRowSelect = useCallback((id) => {
      setSelectedRows((prev) => {
         if (prev.includes(id)) {
            return prev?.filter((rowId) => rowId !== id);
         } else {
            return [...prev, id];
         }
      });
   }, []);

   const ActionBar = {
      Root: ({ open, children }) => (open ? children : null),
      Positioner: ({ children }) => (
         <div className="fixed bottom-6 left-0 right-0 flex justify-center px-4 z-50">{children}</div>
      ),
      Content: ({ children }) => (
         <div
            className={`flex items-center gap-4 px-6 py-3 rounded-2xl shadow-2xl backdrop-blur-xl transition-all border-2 ${
               isDark ? 'bg-slate-900/95 border-slate-700' : 'bg-white border-gray-300'
            }`}>
            {children}
         </div>
      ),
      SelectionTrigger: ({ children }) => (
         <span className={`font-bold text-sm ${isDark ? 'text-slate-100' : 'text-gray-800'}`}>{children}</span>
      ),
      Separator: () => <div className={`h-6 w-px ${isDark ? 'bg-slate-600' : 'bg-gray-400'}`} />,
   };

   const selectedCount = selectedRows.length;

   const handleMultiDelete = () => {
      if (selectedRows.length > 0 && onMultiDeleteClick) {
         onMultiDeleteClick(selectedRows);
         clearSelections();
      }
   };

   const clearSelections = () => {
      setSelectedRows([]);
   };

   const handleRowClick = useCallback((item) => {
      console.log('📋 Row clicked for:', item?.id);
      if (callbacksRef.current.handleViewSingleData && item?.id) {
         callbacksRef.current.handleViewSingleData(item.id);
      } else {
         console.error('Missing handleViewSingleData or item ID');
      }
   }, []);

   const handleEditClick = useCallback(
      (item) => {
         console.log('✏️ Edit clicked for:', item?.id);

         if (!item) {
            console.error('No item provided for edit');
            return;
         }

         // Set current row
         if (callbacksRef.current.setCurrentRow) {
            callbacksRef.current.setCurrentRow(item);
         }

         // Set edit mode
         if (callbacksRef.current.setIsEditMode) {
            callbacksRef.current.setIsEditMode(true);
         }

         // Open modal
         if (callbacksRef.current.onOpen) {
            callbacksRef.current.onOpen();
         }

         // Close single view if needed
         if (
            callbacksRef.current.setIsOpenSingleView &&
            emptyMessage !== 'No Journal voucher data found' &&
            emptyMessage !== 'No IMEI data found'
         ) {
            callbacksRef.current.setIsOpenSingleView(false);
         }
      },
      [emptyMessage],
   );

   const handleDeleteClick = useCallback(
      (item) => {
         console.log('🗑️ Delete clicked for:', item?.id);

         if (!item) {
            console.error('No item provided for delete');
            return;
         }

         const itemId = item?.id || item;

         if (type === 'cash' || type === 'bank') {
            // For cash/bank types
            if (callbacksRef.current.onDeleteClick) {
               callbacksRef.current.onDeleteClick(itemId);
            }
         } else {
            // For other types
            if (callbacksRef.current.setSelectedRowId) {
               callbacksRef.current.setSelectedRowId(itemId);
            }
            if (callbacksRef.current.setDeleteDialogOpen) {
               callbacksRef.current.setDeleteDialogOpen(true);
            }
         }
      },
      [type],
   );

   const handleLogClick = useCallback((item) => {
      console.log('📊 Log clicked for:', item?.id);
      if (callbacksRef.current.onLogClick) {
         callbacksRef.current.onLogClick(item);
      }
   }, []);

   const handleStatusChangeClick = useCallback((id, status) => {
      console.log('🔄 Status change for:', id, 'to:', status);
      if (callbacksRef.current.handleStatusChange) {
         callbacksRef.current.handleStatusChange(id, status);
      }
   }, []);

   const handleSelectAll = useCallback(() => {
      if (selectedRows.length === data.length) {
         setSelectedRows([]);
      } else {
         setSelectedRows(data.map((item) => item.id));
      }
   }, [selectedRows.length, data]);

   const getItemSize = useCallback((index) => {
      if (heightMap.current) {
         return heightMap.current.get(index) || 60;
      }
      return 60;
   }, []);

   const setSize = useCallback((index, size) => {
      if (heightMap.current) {
         heightMap.current.set(index, size);
         listRef.current?.resetAfterIndex(index);
      }
   }, []);

   const itemData = useMemo(() => {
      return {
         items: data,
         columnVisibility,
         columnsData,
         selectedRows,
         showActionsColumn,
         totalWidth,
         columnWidths,
         shouldUseFlexColumns,
         Admin,
         right,
         receiveRight,
         paymentRight,
         type,
         entityType,
         user,
         isDark,
         // Handler functions - PASS THEM HERE
         onRowSelect: handleRowSelect,
         onRowClick: handleRowClick,
         onEditClick: handleEditClick,
         onDeleteClick: handleDeleteClick,
         onLogClick: handleLogClick,
         onStatusChange: handleStatusChangeClick,
      };
   }, [
      data,
      columnVisibility,
      columnsData,
      selectedRows,
      showActionsColumn,
      totalWidth,
      columnWidths,
      shouldUseFlexColumns,
      Admin,
      right,
      receiveRight,
      paymentRight,
      type,
      entityType,
      user,
      isDark,
      handleRowSelect,
      handleRowClick,
      handleEditClick,
      handleDeleteClick,
      handleLogClick,
      handleStatusChangeClick,
   ]);

   const shouldShowMultiDelete = useMemo(() => {
      if (selectedCount === 0) return false;
      if (Admin) return true;
      if (!right?.deleteRole) return false;

      const selectedItems = data.filter((item) => selectedRows.includes(item.id));

      if (type === 'cash' || type === 'bank') {
         return selectedItems.every((item) => {
            if (item?.txnType === 0) {
               return receiveRight?.deleteRole;
            } else if (item?.txnType === 1) {
               return paymentRight?.deleteRole;
            }
            return true;
         });
      }

      if (['city', 'state', 'country'].includes(type?.toLowerCase())) {
         return true;
      }

      return selectedItems.every((item) => {
         if (entityType === 'Unit') {
            return !!item?.usercode;
         }
         if (entityType === 'Group') {
            return !!item?.userCode;
         }
         return true;
      });
   }, [
      selectedCount,
      Admin,
      right?.deleteRole,
      receiveRight?.deleteRole,
      paymentRight?.deleteRole,
      entityType,
      type,
      data,
      selectedRows,
   ]);

   return (
      <div
         ref={containerRef}
         className={`w-full transition-all border-2 rounded-lg ${
            isDark ? 'bg-slate-900/90 border-slate-800' : 'bg-white border-gray-300'
         }`}
         style={{ height: '700px', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
         {/* Header */}
         <div
            ref={headerScrollRef}
            onScroll={handleHeaderScroll}
            style={{
               overflowX: 'auto',
               overflowY: 'hidden',
               scrollbarWidth: 'none',
               msOverflowStyle: 'none',
            }}
            className="sticky top-0 z-10">
            <HeaderRow
               columnsData={columnsData}
               columnVisibility={columnVisibility}
               selectedRows={selectedRows}
               onSelectAll={handleSelectAll}
               totalItems={data.length}
               showActionsColumn={showActionsColumn}
               totalWidth={totalWidth}
               columnWidths={columnWidths}
               shouldUseFlexColumns={shouldUseFlexColumns}
            />
         </div>

         {/* Data */}
         {data.length === 0 && !isLoading ? (
            <div className="flex items-center justify-center p-8 h-full">
               <div className="text-center">
                  <p className={`text-lg font-semibold ${isDark ? 'text-slate-300' : 'text-gray-700'}`}>
                     {emptyMessage || 'No data found'}
                  </p>
               </div>
            </div>
         ) : (
            <InfiniteLoader
               isItemLoaded={isItemLoaded}
               itemCount={hasMore ? data.length + 10 : data.length}
               loadMoreItems={loadMoreItems}
               minimumBatchSize={10}
               threshold={3}>
               {({ onItemsRendered, ref }) => (
                  <List
                     ref={(list) => {
                        listRef.current = list;
                        ref(list);
                     }}
                     height={650}
                     width="100%"
                     itemCount={hasMore ? data.length + 10 : data.length}
                     itemSize={getItemSize}
                     itemData={itemData}
                     onItemsRendered={onItemsRendered}
                     overscanCount={5}
                     style={{ overflowX: 'auto', overflowY: 'auto' }}>
                     {VirtualRow}
                  </List>
               )}
            </InfiniteLoader>
         )}

         {/* Action Bar */}
         <ActionBar.Root open={shouldShowMultiDelete}>
            <ActionBar.Positioner>
               <ActionBar.Content>
                  <ActionBar.SelectionTrigger>
                     <span
                        className={`inline-flex items-center justify-center w-7 h-7 rounded-full mr-2 text-xs font-bold ${
                           isDark ? 'bg-blue-500 text-white' : 'bg-blue-600 text-white'
                        }`}>
                        {selectedCount}
                     </span>
                     selected
                  </ActionBar.SelectionTrigger>
                  <ActionBar.Separator />
                  <button
                     onClick={clearSelections}
                     className={`p-2 rounded-lg transition-all ${
                        isDark ? 'text-slate-300 hover:bg-slate-700' : 'text-gray-600 hover:bg-gray-100'
                     }`}>
                     <CloseIcon className="w-4 h-4" />
                  </button>
                  {user && !user.isExpired && (
                     <button
                        onClick={handleMultiDelete}
                        className={`flex items-center gap-2 px-4 py-2 rounded-lg font-bold text-sm transition-all border-2 ${
                           isDark
                              ? 'text-rose-400 border-rose-500/50 hover:bg-rose-500/20'
                              : 'text-rose-700 border-rose-400 hover:bg-rose-100'
                        }`}>
                        <DeleteIcon className="w-4 h-4" />
                        Delete
                     </button>
                  )}
               </ActionBar.Content>
            </ActionBar.Positioner>
         </ActionBar.Root>
      </div>
   );
};

export default DynamicTable;
